<template>
  <div class="text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t('alerts.title')}}</h3>
      </div>
      <div class="row m-5">
        <div class="col-md-12">
          <!-- <card> -->
            <el-tabs v-model="status" @tab-click="handleTabClick" type="card">
              <el-tab-pane :label="$t('notifications.status_news')" name="unread">
                <master-table resource="alerts" :filters="filters" sotkey="date">
                </master-table>
              </el-tab-pane>
              <el-tab-pane :label="$t('notifications.status_archived')" name="archived">
                <master-table resource="alerts" :filters="filters" sotkey="date">
                </master-table>
              </el-tab-pane>
            </el-tabs>
          <!-- </card> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, } from '@/components';
import {Tabs, TabPane } from 'element-ui'
import MasterTable from '../../pages/components/MasterTable.vue';

export default {
  components: {
    Card,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    MasterTable
  },
  name: 'notifications',
  data() {
    return {
      status: 'unread',
    }
  },
  computed: {
      filters() {return this.status == 'unread' ? 'f[status]=unread&f[status]=readed' : `f[status]=archived`}
  },
  methods: {
    handleTabClick(tab) { }
  }
};
</script>
<style>
</style>